import { collections } from "@/mocks/homeData";

export default function Collections() {
  return (
    <section id="collections" className="shell-wrap py-14 md:py-20">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="section-eyebrow">
            <i className="ri-book-2-fill" /> 合集大全
          </p>
          <h2 className="title-serif mt-2 text-2xl font-black md:text-4xl">
            91黑料 合集与专题总览
          </h2>
          <p className="mt-2 max-w-2xl text-sm text-ink/60 md:text-base">
            将分散的人物、事件、时间线收拢成可直接查阅的清单，按热度与题材分区，冷热兼顾。
          </p>
        </div>
        <div className="flex gap-2">
          {["全部", "人物", "事件", "行业"].map((f, i) => (
            <button
              key={f}
              type="button"
              className={
                "rounded-full px-4 py-1.5 text-sm font-semibold transition-colors cursor-pointer " +
                (i === 0
                  ? "bg-ink text-white"
                  : "border border-ink/15 bg-paper text-ink/65 hover:border-ember hover:text-ember")
              }
            >
              {f}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {collections.map((item, idx) => (
          <article
            key={item.title}
            className="group card-lift flex flex-col overflow-hidden rounded-2xl border border-ink/10 bg-paper"
          >
            <div className="relative h-44 w-full overflow-hidden md:h-48">
              <img
                src={item.image}
                alt={item.title}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/30 to-transparent" />
              <span className="absolute left-3 top-3 rounded-full bg-white/90 px-2.5 py-1 text-[11px] font-bold text-ink">
                合集 {String(idx + 1).padStart(2, "0")}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-4 md:p-5">
              <h3 className="title-serif text-base font-black md:text-lg">{item.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-ink/65">{item.desc}</p>
              <div className="mt-4 flex flex-wrap items-center justify-between gap-2">
                <div className="flex flex-wrap gap-1.5">
                  {item.tags.map((t) => (
                    <span
                      key={t}
                      className="rounded-md bg-ember/10 px-2 py-0.5 text-[11px] font-semibold text-ember"
                    >
                      {t}
                    </span>
                  ))}
                </div>
                <span className="inline-flex items-center gap-1 text-xs font-bold text-ink/50">
                  查看清单 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}